import type { TFile } from "./types";
import { HTTP } from "@/api";
import { type AxiosProgressEvent } from "axios";
import { getPathParam } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "/api/v1/file";

export default createService(SLUG, {
  upload: async (
    formData: FormData,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ) =>
    HTTP.post<TFile>(`${SLUG}/upload/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 5 * 60 * 1000, // 5 minutes
      onUploadProgress,
    }),

  detail: getPathParam<TFile, { id: string }>(`${SLUG}/attachments/{id}`),
});
